import { LinkList } from '../../LinkList';

/**
 * 関連リンクPropsを生成する
 * @param responseLinkList nameとurlプロパティを持つリスト
 * @param separator 要素間に表示する文字列
 * @returns LinkList 関連リンク
 */
export const createLinkList = <
  T extends {
    name?: string | undefined;
    url?: string | undefined;
    count?: number | undefined;
  }[],
>(
  responseLinkList: T | undefined,
  separator: string
): LinkList => {
  return {
    separator,
    list: responseLinkList?.length
      ? responseLinkList
          .map(({ name, url, count }) => ({
            text: name ?? '',
            href: url ?? '',
            count,
          }))
          .filter(nonNullableText)
      : [],
  };
};

/**
 * いずれかのパラメーターがfalsyな値の場合削除する
 * @param {Text, href} linkItem
 * @returns boolean
 */
export const nonNullableText = ({
  text,
  href,
}: {
  text: string | undefined;
  href: string | undefined;
}) => !!text && !!href;
